var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 5.785156 L 26.855469 5.785156 L 26.855469 12 L 8 12 Z M 8 5.785156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 11 L 26.855469 11 L 26.855469 18 L 8 18 Z M 8 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 17 L 26.855469 17 L 26.855469 23.207031 L 8 23.207031 Z M 8 17 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.90625 5.785156 L 9 5.785156 L 9 23.207031 L 2.90625 23.207031 Z M 2.90625 5.785156 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2.349854%, 50.979614%, 25.489807%)",
    d: "M 24.191406 5.785156 L 8.894531 5.785156 L 8.894531 11.816406 L 26.851562 11.816406 L 26.851562 8.464844 C 26.851562 6.984375 25.660156 5.785156 24.191406 5.785156 Z M 24.191406 5.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93.328857%, 93.328857%, 93.328857%)",
    d: "M 8.894531 11.816406 L 26.851562 11.816406 L 26.851562 17.175781 L 8.894531 17.175781 Z M 8.894531 11.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(7.839966%, 7.839966%, 7.839966%)",
    d: "M 8.894531 23.207031 L 24.191406 23.207031 C 25.660156 23.207031 26.851562 22.003906 26.851562 20.527344 L 26.851562 17.175781 L 8.894531 17.175781 Z M 8.894531 23.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92.549133%, 12.548828%, 15.689087%)",
    d: "M 5.570312 5.785156 C 4.101562 5.785156 2.910156 6.984375 2.910156 8.464844 L 2.910156 20.527344 C 2.910156 22.003906 4.101562 23.207031 5.570312 23.207031 L 8.894531 23.207031 L 8.894531 5.785156 Z M 5.570312 5.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0d0379ce3727ca2f75b15315014e214a.svg";
export { ForwardRef as ReactComponent };